export type GridLayout = '2x2' | '3x3'

export interface DashboardWidget {
  id: string
  title: string
  component: string
  visible: boolean
  order: number
}

export interface DashboardLayoutConfig {
  gridLayout: GridLayout
  widgets: DashboardWidget[]
}

export const DEFAULT_WIDGETS: DashboardWidget[] = [
  { id: 'quick-actions', title: 'Quick Actions', component: 'QuickActionsWidget', visible: true, order: 0 },
  { id: 'weekly-activity', title: 'Weekly Activity', component: 'WeeklyActivityWidget', visible: true, order: 1 },
  { id: 'recent-activity', title: 'Recent Activity', component: 'RecentActivityWidget', visible: true, order: 2 },
  { id: 'projects', title: 'My Projects', component: 'ProjectsWidget', visible: true, order: 3 },
  { id: 'deadlines', title: 'Upcoming Deadlines', component: 'DeadlinesWidget', visible: true, order: 4 },
  { id: 'completion-rate', title: 'Completion Rate', component: 'CompletionRateWidget', visible: true, order: 5 }
]

export const DEFAULT_LAYOUT_CONFIG: DashboardLayoutConfig = {
  gridLayout: '2x2',
  widgets: DEFAULT_WIDGETS
}

export function getGridColumns(layout: GridLayout): number {
  switch (layout) {
    case '2x2': return 2
    case '3x3': return 3
    default: return 2
  }
}
